import React, { Component, createRef } from 'react';
import DropIn from "braintree-web-drop-in-react";
import axios from 'axios';
import swal from 'sweetalert';
import DatePicker from 'react-date-picker';
import { getApiHeaderGuest } from "../../../../utils/CommonFunctions";
import SimpleReactValidator from 'simple-react-validator';
import ErrorMsg from '../../../public/errorMsg';
import PageLoader from '../../../Loader/loader';
import Loader from "react-loader-spinner";
import SignatureCanvas from 'react-signature-canvas';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export class PostPaidPaymentMethod extends Component {

    constructor(props) {

        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            CardName: '',
            cardNumber: '',
            cardExpiry: '',
            cardCvv: '',
            termsCheckerr: false,
            plan_id: 1,
            cardExp: '',
            termsCheck: false,
            isCredit: 0,
            autoRechargeStatus: false,
            autoRechargeStatusCheck: false,
            autoRecharge: true,
            autoRechargeCheck: "checked",
            paymentDetails: [],
            totalAmount: 0,
            loading: true,
            clientToken: null,
            takefull_amount: null,
            port_in_check_message: null,
            payable_amount: null,
            paymsg: null,
            special_sim: 0,
            card_display_status: false,
            premiumNumberdata: "",

            isSubmitting: false,
            hasSignature: false,
            signatureData: null, // Store signature stroke data
            signatureError: "",
            is_wme_prepaid: 0,
        }

        this.signatureRef = createRef();
        this.cleanupViewportListeners = null;
    }


    CardName = (event) => { this.setState({ CardName: event.target.value }); }
    cardNumber = (event) => { this.setState({ cardNumber: event.target.value }); }
    cardExpiry = (expiry) => {
        let year = expiry.getFullYear();
        let month = expiry.getMonth() + 1;
        let cardDate = month + '/' + year;

        this.setState({ cardExpiry: expiry, cardExp: cardDate });

    }
    cardCvv = (event) => { this.setState({ cardCvv: event.target.value }); }
    autoRecharge = (renew) => {


        this.setState({ autoRecharge: renew }, () => {


            let check = this.state.autoRecharge === true ? "checked" : null;

            this.setState({ autoRechargeCheck: check });

        });


    }
    termsCheck = (check) => { this.setState({ termsCheck: check, termsCheckerr: false }); }

    autoRechargeStatusCheck = (check) => { this.setState({ autoRechargeStatusCheck: check, autoRechargeStatus: check ? true : false, }); }


    componentDidMount = async () => {

        this.getPaymentClientToken();


        setTimeout(() => {
            if (this.signatureRef.current) {
                const canvas = this.signatureRef.current.getCanvas();
                canvas.style.width = '100%';
                canvas.style.height = '150px';

                // Restore signature if it exists
                if (this.state.signatureData) {
                    try {
                        this.signatureRef.current.fromData(this.state.signatureData);
                    } catch (error) {
                        console.warn('Failed to restore signature on mount:', error);
                    }
                }
            }
        }, 100);

        // Add viewport change listeners for mobile
        this.addViewportListeners();





        try {

            let headers = await getApiHeaderGuest();

            let inputData = { session_id: sessionStorage.getItem('activation_session_id') };

            let res = await axios.post(`${SERVER_URL}postpaid/activation/payments/get-selected-items`, inputData, { headers });

            let response = res.data.data;
            this.setState({ premiumNumberdata: res.data.data })
            this.setState({is_wme_prepaid:response.is_wme_prepaid })

            this.setState({ paymentDetails: response.plan, totalAmount: response.total_sell_amount, loading: false, takefull_amount: response.takefull_amount, port_in_check_message: response.port_in_check_message, payable_amount: response.payable_amount, special_sim: response.special_sim, isCredit: response.is_credit });
            if (response.pay_msg) { this.setState({ paymsg: response.pay_msg }); }
            if (response.special_sim === 1) {
                this.setState({ autoRechargeStatus: true })
            }

            if (response.special_sim === 0 && response.is_credit === 0) {
                this.setState({ autoRechargeStatusCheck: true, autoRechargeStatus: true });
            }

            if (response.card_display_status === true) {
                this.setState({ autoRechargeStatusCheck: true, autoRechargeStatus: true, card_display_status: true });
            }

        }
        catch (err) {

            this.setState({ loading: false });

            if (err) {
                let errorMessage = '';

                if (err.response && err.response.data && err.response.data.message) {
                    if (typeof (err.response.data.message) === 'object') {

                        swal({
                            title: "Error",
                            content: <ErrorMsg message={err.response.data.message} />,
                            icon: "error"
                        });

                    }
                    else {
                        errorMessage = err.response.data.message;
                        swal(errorMessage, "error");

                    }
                }
                else {
                    errorMessage = err;
                    swal(errorMessage, err);
                }



            }


        }

    }


    handleSubmitButtonClick = (event) => {
        // this.setState({ loading: true });
        if (this.state.special_sim === 0) {
            if (this.state.isCredit === 1 && !this.state.autoRechargeStatusCheck) {
                this.mySubmitActivationHandler(event);
            } else {
                this.mySubmitHandler(event);
            }
        } else {
            this.mySubmitActivationHandler(event);
            // Handle the condition accordingly for special_sim !== 0
        }
    }




    mySubmitHandler = async (event) => {
        event.preventDefault();

        if (this.validator.allValid() === false) {
            this.setState({ loading: false });
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }

        if (this.state.termsCheck === true) {
            let signatureImage
            if (this.state.is_wme_prepaid !== 1) {
                signatureImage = this.getSignatureImage();
                if (!signatureImage) {
                    this.setState({
                        signatureError: 'Please provide your signature',
                        loading: false
                    });
                    return;
                }
            }


            try {
                const { nonce } = await this.instance.requestPaymentMethod();

                this.setState({ loading: true });

                const post_data = {
                    is_credit: this.state.isCredit,
                    automate_recharge: this.state.autoRechargeStatus ? 1 : 0,
                    payable_amount: this.state.payable_amount,
                    takefull_amount: this.state.takefull_amount,
                    termsCheck: this.state.termsCheck,
                    auto_renew: this.state.autoRecharge,
                    session_id: sessionStorage.getItem('activation_session_id'),
                    nonce: nonce,
                    signature: signatureImage,
                };

                let headers = await getApiHeaderGuest();

                const response = await axios.post( `${SERVER_URL}postpaid/activation/payments/submit-payment`,post_data,{ headers });

                this.setState({ loading: false });
                console.log("this.props.postPaidBiometicProps?.postPaidBiometricValue", this.props.postPaidBiometicProps)

                if (response.status === 200) {
                    if (this.props.postPaidBiometicProps) {

                        const wrapper = document.createElement("div");
                        wrapper.innerHTML = response.data?.message;

                        swal({
                            title: "Payment Successful",
                            content: wrapper,
                            icon: "success",
                            className: "biometic-payment-gateway-swal",
                            buttons: {
                                confirm: {
                                    text: "Confirm",
                                    value: true,
                                    visible: true,
                                    closeModal: true
                                },
                                cancel: {
                                    text: "Cancel",
                                    value: false,
                                    visible: true
                                },
                            }
                        }).then((willConfirm) => {
                            if (willConfirm) {
                                this.handleBiometricProcess();
                            } else {
                                window.location.reload();
                            }
                        });

                    } else {
                        this.props.nextStep();
                    }
                }

            } catch (error) {
                this.setState({ loading: false });

                if (error?.response?.data?.message) {
                    this.setErrorMessages(error.response.data.message, 'warning');
                } else {
                    swal("complete your payment method details to continue", "", 'warning');
                }
            }

        } else {
            this.setState({ termsCheckerr: true, loading: false });
        }
    };



    handleBiometricProcess = async () => {
        try {
            this.setState({ loading: true });
            const headers = await getApiHeaderGuest()
            const post_data = {
                is_credit: this.state.isCredit,
                automate_recharge: this.state.autoRechargeStatus ? 1 : 0,
                payable_amount: this.state.payable_amount,
                takefull_amount: this.state.takefull_amount,
                termsCheck: this.state.termsCheck,
                auto_renew: this.state.autoRecharge,
                session_id: sessionStorage.getItem("activation_session_id"),
            };

            const response = await axios.post(`${SERVER_URL}postpaid/activation/biometric-confirmation-postpaid`, post_data, { headers })

            if (response.status === 200) {
                swal(response.data?.message || response.data?.data?.message || "success", "", "success")
                    .then(() => {
                        window.location.reload();
                    });
                this.setState({ loading: false });
                return;
            }
        } catch (error) {
            this.setState({ loading: false });
            swal(error.response.data?.message || "", "", "error").then(() => {
                window.location.reload();
            });
        }

    }





    getPaymentClientToken = async () => {

        try {

            let headers = await getApiHeaderGuest();

            let res = await axios.get(`${SERVER_URL}payments/get-client-token`, { headers });

            let response = res.data.data;

            this.setState({ clientToken: response.clientToken });

        }
        catch (err) {

            this.setState({ loading: false });

            if (err) {
                let errorMessage = '';

                if (err.response && err.response.data && err.response.data.message) {
                    if (typeof (err.response.data.message) === 'object') {

                        swal({
                            title: "Error",
                            content: <ErrorMsg message={err.response.data.message} />,
                            icon: "error"
                        });

                    }
                    else {
                        errorMessage = err.response.data.message;
                        swal(errorMessage, "error");

                    }
                }
                else {
                    errorMessage = err;
                    swal(errorMessage, err);
                }



            }


        }

    }

    setErrorMessages = (errorMessage, type) => {

        //let responseError = []

        let responseError = 'Internal server error';

        if (typeof (errorMessage) !== 'undefined' && errorMessage != null) {
            if (typeof errorMessage === 'object') {

                responseError = '';

                Object.keys(errorMessage).map(function (key, index) {

                    // responseError.push(errorMessage[key]);
                    responseError += errorMessage[key];

                });

            }
            else {
                responseError = errorMessage;
            }

        }

        swal(responseError, "", type);

    }

    back = e => {
        e.preventDefault();
        this.props.prevStep();
    };






    mySubmitActivationHandler = async (event) => {

        event.preventDefault();

        if (this.validator.allValid() == false) {

            this.setState({ loading: false });

            this.validator.showMessages();
            this.forceUpdate();
            return;
        }

        if (this.state.termsCheck === true) {


            this.setState({ loading: true });

            const post_data = {
                termsCheck: this.state.termsCheck,
                session_id: sessionStorage.getItem('activation_session_id')
            };

            let headers = await getApiHeaderGuest();

            let res = await axios.post(`${SERVER_URL}activation/payments/special-activation`, post_data, { headers }).then(response => {

                this.setState({ loading: false });

                this.props.nextStep();

            }).catch(error => {

                this.setState({ loading: false });

                if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {
                    this.setErrorMessages(error.response.data.message, 'warning');
                }
                else {
                    swal("Internal Server Error", "", 'warning');
                }

            });

        }
        else {
            this.setState({ termsCheckerr: true, loading: false });
        }
    };



    handleSignatureEnd = () => {
        if (!this.signatureRef.current.isEmpty()) {
            try {
                // Save the signature stroke data for restoration
                const signatureData = this.signatureRef.current.toData();
                this.setState((prevState) => ({
                    hasSignature: true,
                    signatureData: signatureData, // Store the signature data
                    signatureError: "",
                    errors: {
                        ...prevState.errors,
                        signature: ""
                    }
                }));
            } catch (error) {
                console.warn('Failed to save signature data:', error);
                // Fallback - just mark as having signature
                this.setState((prevState) => ({
                    hasSignature: true,
                    errors: {
                        ...prevState.errors,
                        signature: ""
                    }
                }));
            }
        }
    };

    // Enhanced clear signature with data cleanup
    clearSignature = () => {
        if (this.signatureRef.current) {
            this.signatureRef.current.clear();
        }
        this.setState((prevState) => ({
            hasSignature: false,
            signatureData: null, // Clear stored signature data
            errors: {
                ...prevState.errors,
                signature: ''
            },
            signatureError: "",
        }));
    };

    addViewportListeners = () => {
        let timeoutId;
        const handleViewportChange = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                if (this.signatureRef.current && this.state.signatureData) {
                    // Restore signature after viewport stabilizes
                    try {
                        this.signatureRef.current.fromData(this.state.signatureData);
                    } catch (error) {
                        console.warn('Failed to restore signature:', error);
                    }
                }
            }, 300); // Wait for viewport to stabilize
        };

        window.addEventListener('resize', handleViewportChange);
        window.addEventListener('orientationchange', handleViewportChange);

        // Store cleanup function
        this.cleanupViewportListeners = () => {
            window.removeEventListener('resize', handleViewportChange);
            window.removeEventListener('orientationchange', handleViewportChange);
            clearTimeout(timeoutId);
        };

        // Enhanced iOS Safari detection and handling
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

        if (isIOS) {
            let initialViewportHeight = window.innerHeight;
            let keyboardDetectionTimeout;

            const handleIOSViewportChange = () => {
                clearTimeout(keyboardDetectionTimeout);

                keyboardDetectionTimeout = setTimeout(() => {
                    const currentViewportHeight = window.innerHeight;
                    const heightDifference = initialViewportHeight - currentViewportHeight;

                    // If height decreased significantly, keyboard is likely open
                    if (heightDifference > 150) {
                        // Keyboard opened - preserve current signature
                        if (this.signatureRef.current && !this.signatureRef.current.isEmpty()) {
                            try {
                                const currentSignatureData = this.signatureRef.current.toData();
                                this.setState({ signatureData: currentSignatureData });
                            } catch (error) {
                                console.warn('Failed to save signature data:', error);
                            }
                        }
                    } else if (heightDifference < 50) {
                        // Keyboard closed - restore signature after a delay
                        setTimeout(() => {
                            if (this.signatureRef.current && this.state.signatureData) {
                                try {
                                    this.signatureRef.current.fromData(this.state.signatureData);
                                } catch (error) {
                                    console.warn('Failed to restore signature on iOS:', error);
                                }
                            }
                        }, 200);
                    }
                }, 100);
            };

            window.addEventListener('resize', handleIOSViewportChange);

            // Update cleanup function to include iOS listeners
            const originalCleanup = this.cleanupViewportListeners;
            this.cleanupViewportListeners = () => {
                originalCleanup();
                window.removeEventListener('resize', handleIOSViewportChange);
                clearTimeout(keyboardDetectionTimeout);
            };
        }
    };

    getSignatureImage = () => {
        if (this.signatureRef.current.isEmpty()) {
            return null;
        }

        const canvas = this.signatureRef.current.getCanvas();
        const ctx = canvas.getContext('2d');

        // Create a new canvas with white background
        const newCanvas = document.createElement('canvas');
        const newCtx = newCanvas.getContext('2d');

        newCanvas.width = canvas.width;
        newCanvas.height = canvas.height;

        // Fill with white background
        newCtx.fillStyle = 'white';
        newCtx.fillRect(0, 0, newCanvas.width, newCanvas.height);

        newCtx.drawImage(canvas, 0, 0);

        return newCanvas.toDataURL('image/png');
    };



    render() {
        const { values } = this.props;


        // console.log("this.props.postPaidBiometicProps?.postPaidBiometricValue", this.props.postPaidBiometicProps)


        return (
            <>
                {(this.state.loading === true) ? <PageLoader /> : null}
                <form className="kt-form kt-section__content kt-section__content--border common-layout" id="kt_form">
                    <div className="kt-wizard-v2__content" data-ktwizard-type="step-content">

                        <p style={{ color: "#000", fontSize: "16px", marginBottom: 0 }}>{(this.state.paymsg)}</p>

                        <div className="kt-form__section kt-form__section--first" id="card_section">

                            {(this.state.clientToken !== null && this.state.special_sim === 0 && this.state.autoRechargeStatusCheck === true) ?
                                <>
                                    <DropIn options={{
                                        authorization: this.state.clientToken, card: {
                                            cardholderName: { 'required': true },
                                            overrides: {
                                                styles: {
                                                    input: {
                                                        width: '100%'
                                                    }
                                                }
                                            }

                                        }
                                    }}
                                        onInstance={(instance) => (this.instance = instance)}
                                    />
                                </>

                                :
                                <div style={{ width: "100%" }}>
                                    {this.state.special_sim === 0 && this.state.autoRechargeStatusCheck === true ?
                                        <p style={{ textAlign: "center", fontSize: "18px", color: "#C11d6c", fontWeight: "bold" }}>Loading...</p>
                                        : null}
                                </div>
                            }

                            {this.state.is_wme_prepaid !== 1 && (
                                <div className="mb-3 mt-3">
                                    <label className="form-label  sim-only-activation-label-sign">Digital Signature<span style={{ color: "red" }}>* </span></label>
                                    <div
                                        className="border rounded signature-container"
                                        style={{
                                            backgroundColor: '#fff',
                                            maxWidth: '500px',
                                            height: '120px',
                                            touchAction: 'none',
                                            position: 'relative',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <SignatureCanvas
                                            ref={this.signatureRef}
                                            penColor="black"
                                            dotSize={1}
                                            minWidth={0.5}
                                            maxWidth={2}
                                            velocityFilterWeight={0.7}
                                            minDistance={5}
                                            throttle={16}
                                            canvasProps={{
                                                className: 'signature-canvas',
                                                style: {
                                                    backgroundColor: '#fff',
                                                    width: '100%',
                                                    height: '150px',
                                                    border: '1px dashed #ccc',
                                                    touchAction: 'none',
                                                    display: 'block'
                                                }
                                            }}
                                            onEnd={this.handleSignatureEnd}
                                        />
                                    </div>
                                    {this.state.signatureError && <div className="post-paid-common-error">{this.state.signatureError}</div>}
                                    <div className='mb-2'>
                                        <button
                                            type="button"
                                            className="btn btn-md btn-danger mt-2"
                                            onClick={this.clearSignature}
                                        >
                                            Clear Signature
                                        </button>
                                    </div>
                                </div>

                            )}



                            <div className="kt-invoice-1">
                                <div className="kt-invoice__body kt-padding-10" id="payment_cart">
                                    <div className="kt-invoice__container" style={{ width: "100%", margin: "0 auto" }}>
                                        <div className="table-responsive">


                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>DESCRIPTION</th>
                                                        <th>AMOUNT DUE</th>
                                                    </tr>
                                                </thead>
                                                <tbody>


                                                    {this.state.paymentDetails.map((data) => {

                                                        return <tr><td>{data.discription}</td><td>${Number(data.amount).toFixed(2)}</td></tr>

                                                    })}

                                                    {this.state.premiumNumberdata.premium_number_amount && (
                                                        <>
                                                            <tr> <td> Premium Number Amount    <span style={{ color: "#C11D6C" }}>({this.state.premiumNumberdata.premium_category_name}) </span>    </td>  <td>{this.state.premiumNumberdata.premium_number_amount}  </td>   </tr>
                                                            {/* <tr> <td> Premium Number Category Name </td>  <td>{this.state.premiumNumberdata.premium_category_name}  </td>   </tr> */}
                                                            <i>{this.state.premiumNumberdata.premium_number_amount_text} </i>
                                                        </>

                                                    )
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="kt-invoice__footer kt-padding-10">
                                        <div className="kt-invoice__container" style={{ width: "100%", margin: "0 auto" }}>
                                            <div className="kt-invoice__bank">
                                            </div>
                                            <div className="kt-invoice__total pull-right">

                                                <span className="kt-invoice__title">TOTAL AMOUNT</span>

                                                <span className="kt-invoice__price"> ${Number(this.state.totalAmount).toFixed(2)}</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {this.state.is_wme_prepaid === 1 ? (
                                <>
                                    <div className="row">
                                        {(this.state.special_sim === 0 && this.state.autoRechargeStatus === true) ?
                                            <div className="col-lg-12">
                                                <label>Your card will be charged 1 AUD for card preauthorization. This pending transaction will be voided by your bank automatically within 7-14 business days. This payment method will be used for all future payments for this account. Payment method can be updated anytime in Telsim My Account.</label>
                                            </div> : null}
                                        <div className="col-lg-12">
                                            <div className="form-group  row">

                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    {this.state.isCredit === 1 && this.state.special_sim === 0 && this.state.card_display_status === false && (
                                                        <label className="kt-option">
                                                            <label className="kt-checkbox kt-checkbox--bold kt-checkbox--danger">
                                                                <input type="checkbox" name="auto_recharge_status" id="auto_recharge_status" value="1" onChange={e => { this.autoRechargeStatusCheck(e.target.checked); }} />
                                                                <span></span>
                                                            </label>
                                                            <span className="kt-option__label">
                                                                <span className="kt-option__head">
                                                                    <span className="kt-option__title">
                                                                        I want to set up automatic recharges
                                                                    </span>
                                                                </span>
                                                            </span>
                                                        </label>
                                                    )}


                                                </div>

                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <label className="kt-option">
                                                        <label className="kt-checkbox kt-checkbox--bold kt-checkbox--danger">
                                                            <input type="checkbox" name="agree_terms" id="agree_terms" value="1" onChange={e => { this.termsCheck(e.target.checked); }} />
                                                            <span></span>
                                                        </label>
                                                        <span className="kt-option__label">
                                                            <span className="kt-option__head">
                                                                <span className="kt-option__title">
                                                                    I agree to Telsim's <a href="https://telsim.com.au/terms-and-conditions" target="_blank">terms & conditions</a> and<a href="https://telsim.com.au/website-privacy-policy" target="_blank"> policies.</a>
                                                                </span>

                                                            </span>
                                                        </span>
                                                    </label>

                                                    {this.state.termsCheckerr == true &&
                                                        <span className="" role="alert"><span id="authorized_error" style={{ color: "#C11D6C", fontWeight: '400', paddingTop: '10px', display: 'block' }}><i className="fa fa-exclamation-triangle"></i> Please confirm checkbox</span></span>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </>

                            ) : (
                                <>
                                    <div className="row">

                                        {(this.state.special_sim === 0 && this.state.autoRechargeStatus === true) ?
                                            <div className="col-lg-12">
                                                <label style={{ textAlign: "justify" }}>Your card will be charged 1 AUD for card preauthorization. This pending transaction will be voided by your bank automatically within 7-14 business days. This payment method will be used for all future payments for this account. Payment method can be updated anytime in Telsim My Account.</label>
                                            </div> : null}
                                        <div className="col-lg-12">
                                            <div className="form-group  row">

                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    {this.state.isCredit === 1 && this.state.special_sim === 0 && this.state.card_display_status === false && (
                                                        <label className="kt-option">
                                                            <label className="kt-checkbox kt-checkbox--bold kt-checkbox--danger">
                                                                <input type="checkbox" name="auto_recharge_status" id="auto_recharge_status" value="1" onChange={e => { this.autoRechargeStatusCheck(e.target.checked); }} />
                                                                <span></span>
                                                            </label>
                                                            <span className="kt-option__label">
                                                                <span className="kt-option__head">
                                                                    <span className="kt-option__title">
                                                                        I want to set up automatic recharges
                                                                    </span>
                                                                </span>
                                                            </span>
                                                        </label>
                                                    )}


                                                </div>



                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <div style={{ border: "1px solid #ddd", borderRadius: "6px", padding: "15px", background: "#f9f9f9" }}>

                                                        {/* Authorization Text */}
                                                        <div style={{ marginBottom: "15px", fontSize: "14px", color: "#333", lineHeight: "1.6", textAlign: "justify" }}>
                                                            I authorise Kangaroo Telecom Pty Ltd trading as Telsim Australia (ABN: 84 628 098 966),
                                                            and its appointed payment processor Braintree (a PayPal service), to debit payments from my nominated payment method as per the agreed billing schedule.
                                                            These debits are for payment of my Telsim mobile plan services and may vary in amount depending on the selected plan and usage.
                                                            <br /><br />
                                                            By signing this form:
                                                            <ul style={{ paddingLeft: "18px", margin: "10px 0" }}>
                                                                <li>I acknowledge that I have read and understood the Telsim Direct Debit Service Agreement.</li>
                                                                <li>I authorise Telsim Australia and Braintree to debit my account in accordance with the agreement.</li>
                                                                <li>I understand that dishonour fees may apply if funds are insufficient.</li>
                                                                <li>I will notify Telsim of any change to these account details or cancellation of this authority.</li>
                                                            </ul>
                                                        </div>

                                                        {/* Terms Checkbox */}
                                                        <label className="kt-option" style={{ display: "flex", gap: "10px" }}>
                                                            <label className="kt-checkbox kt-checkbox--bold kt-checkbox--danger" style={{ marginRight: "10px" }}>
                                                                <input
                                                                    type="checkbox"
                                                                    name="agree_terms"
                                                                    id="agree_terms"
                                                                    value="1"
                                                                    onChange={e => { this.termsCheck(e.target.checked); }}
                                                                />
                                                                <span></span>
                                                            </label>
                                                            <span className="kt-option__label">
                                                                <span className="kt-option__head">
                                                                    <span className="kt-option__title  terms-and-conditions-sim-only">
                                                                        {/* I agree to Telsim's <a href="https://telsim.com.au/terms-and-conditions" target="_blank" rel="noopener noreferrer">terms & conditions</a> and
                                                                <a href="https://telsim.com.au/website-privacy-policy" target="_blank" rel="noopener noreferrer"> policies</a>. */}

                                                                        I agree to Telsim’s <a href="https://www.telsim.com.au/standard-form-of-agreement-sim-only-plans" target="_blank"> Standard Form of Agreement</a>  <span style={{ color: "red" }}> *</span> and <a href="https://www.telsim.com.au/critical-information-summary/telsim-upfront-mobile-plans" target="_blank"> Critical Information Summary</a>  <span style={{ color: "red" }}> *</span>.



                                                                    </span>
                                                                </span>
                                                            </span>
                                                        </label>

                                                        {/* Error */}
                                                        {this.state.termsCheckerr === true && (
                                                            <span role="alert">
                                                                <span id="authorized_error" style={{ color: "#C11D6C", fontWeight: '400', paddingTop: '10px', display: 'block' }}>
                                                                    <i className="fa fa-exclamation-triangle"></i> Please confirm checkbox
                                                                </span>
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                            }



                        </div>
                        <br />
                        <div className="kt-form__actions">
                            <button type="submit" className="btn btn-brand btn-md btn-tall btn-wide btn-bold btn-upper  btn-pill btn-sm" id="backBtn" onClick={this.back}>Previous</button>&nbsp;


                            {(this.state.special_sim === 0 && this.state.autoRechargeStatus === true) ?

                                <button type="submit" className="btn btn-brand btn-md btn-tall btn-wide btn-bold btn-upper  btn-pill btn-sm" id="wizard_next_btn" data-ktwizard-type="action-next" disabled={this.state.loading} onClick={(event) => {
                                    // this.setState({loading:true});
                                    this.handleSubmitButtonClick(event);
                                }
                                }>Pay & Proceed</button>

                                :

                                <button type="submit" className="btn btn-brand btn-md btn-tall btn-wide btn-bold btn-upper  btn-pill btn-sm" id="wizard_next_btn" data-ktwizard-type="action-next" disabled={this.state.loading} onClick={(event) => {
                                    // this.setState({loading:true});
                                    this.handleSubmitButtonClick(event);
                                }
                                }>Proceed</button>

                            }


                        </div>

                    </div>
                </form>
            </>
        );
    }
}

export default PostPaidPaymentMethod;
